export const FormFields = [
  {
    label: "School Name",
    type: "text",
    placeholder: "Search school",
    required: true,
    options: "schoolOptions",
  },
  {
    label: "Event Name",
    type: "select",
    placeholder: "Select Event",
    required: true,
    options: "eventNames",
  },
  {
    label: "Event Level",
    type: "select",
    placeholder: "Select Level",
    required: true,
    options: "eventLevelOptions",
  },
  {
    label: "Round",
    type: "select",
    placeholder: "Select Round",
    required: true,
    options: "roundOptions",
  },
  {
    label: "Grade",
    type: "select",
    placeholder: "Select Grade",
    required: true,
    options: "gradeOptions",
  },
  {
    label: "Start Date",
    type: "date",
    placeholder: "Start Date",
    required: true,
  },
  {
    label: "End Date",
    type: "date",
    placeholder: "End Date",
    required: true,
  },
  {
    label: "Start Time",
    type: "time",
    required: true,
  },
  {
    label: "End Time",
    type: "time",
    required: true,
  },
  {
    label: "Timezone",
    type: "select",
    placeholder: "Select Timezone",
    required: true,
    options: "timezoneOptions",
  },
  {
    label: "Description (optional)",
    type: "textarea",
    placeholder: "Description",
    required: false,
  },
];
